import axios from 'axios';
import { Meetingroom, Slot } from '../interfaces/interfaces';
import hybrid from '../public/pagebuilder/presentationplaceholder/hybrid.png';
import online from '../public/pagebuilder/presentationplaceholder/online.png';
import onsite from '../public/pagebuilder/presentationplaceholder/onsite.png';
import { fetchAndSetMeetingrooms, fetchAndSetSlots, setSelectedPresentationLivestreamSlot } from '../reduxToolkit/slices/commonSlice';
import { createSlot, deleteMeeting, deleteSlot, notifySlot } from '../services/services';
import { useMeeting } from './useMeeting';
import { useDispatch } from '../reduxToolkit/typedRedux';

const usePresentations = () => {
  const dispatch = useDispatch();
  const { goToMeeting } = useMeeting();

  //assign a meetingroom to a slots group by creating a slot with the meetingroomId
  async function assignSlot(newSlot: Slot) {
    try {
      await createSlot({
        datetime_start: newSlot.datetime_start,
        datetime_end: newSlot.datetime_end,
        meetingroom: newSlot.meetingroom._id,
        notifyOwners: false,
        sortIndex: newSlot.sortIndex || 0,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async function remindHost(slotid: string, eventid?: string) {
    try {
      await notifySlot(slotid);
      dispatch(fetchAndSetSlots(eventid));
    } catch (err) {
      // into toaster
      console.error(err);
    }
  }

  async function removeSlot(slotid: string, eventid?: string, onRemove?: () => void) {
    try {
      await deleteSlot(slotid);
    } catch (err) {
      // into toaster
      console.error(err);
    }

    if (!eventid) return;
    if (!onRemove) {
      dispatch(fetchAndSetSlots(eventid));
      dispatch(
        fetchAndSetMeetingrooms({
          meetingtype: 'presentation',
          hasSlot: false,
          hasName: true,
          filterEvent: eventid,
          limit: 5000,
        })
      );
    } else onRemove();
  }

  const fetchAndUpdateSlots = (eventid?: string) => dispatch(fetchAndSetSlots(eventid));

  //update the sort indexes of the affected group
  const updateGroup = async (slotsArr: Slot[], eventid?: string) => {
    try {
      for (const slot of slotsArr) await axios.post('/slot/update', { ...slot });
    } catch (error) {
      dispatch(fetchAndSetSlots(eventid));
    }
  };

  const deletePresentation = async (meetingroomId: string, onRemove?: () => void) => {
    try {
      await deleteMeeting(meetingroomId);
    } catch (err) {
      console.error(err);
    }

    onRemove?.();
  };

  const joinPresentation = async (slot: Slot) => {
    if (slot.meetingroom.isStudioForPresentationSlot) {
      dispatch(setSelectedPresentationLivestreamSlot(slot));
    } else {
      goToMeeting(slot);
    }
  };

  const getPlaceholderBackgroundImage = (meetingroom: Meetingroom) => {
    let image = onsite;
    switch (meetingroom.presentationSlotType) {
      case 'online':
        image = online;
        break;
      case 'hybrid':
        image = hybrid;
        break;
      case 'on-site':
      default:
        image = onsite;
        break;
    }

    return image.src;
  };

  return {
    remindHost,
    removeSlot,
    fetchAndUpdateSlots,
    updateGroup,
    assignSlot,
    deletePresentation,
    joinPresentation,
    getPlaceholderBackgroundImage,
  };
};
export default usePresentations;
